import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.js";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  mainPanelFullWidth: {
    [theme.breakpoints.up("md")]: {
      width: "100%"
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "45px",
    [theme.breakpoints.up("md")]: {
      paddingTop: "15px"
    },
    minHeight: "calc(100vh - 123px)"
  },
  container:{
    ...container,
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
      paddingRight: "0px"
    },
  },
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
